import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./PagesCss/QuemSomos.css";
import { GoTriangleRight, GoTriangleLeft } from "react-icons/go";
import ProcessoSeletivo from "./ProcessoSeletivo";
import HeroImage from "../component/HeroImage";

function QuemSomos() {
  // Definindo as seções com títulos e conteúdos na ordem correta
  const sections = [
    {
      title: "CONHEÇA-NOS",
      content: [
        "Somos Custódio Quessada Lima, um ecossistema de soluções que tem a missão de ser a melhor chance que um produtor rural pode ter para defender seus direitos e alcançar justiça. Nossa metodologia é muito simples: focamos em compartilhar informação de forma clara e descodificada para que nossos clientes e usuários compreendam a exata extensão de seus direitos e tenham todos os dados necessários para decidirem de forma consciente “se”, “quando” e “como” irão reivindica-los.",
      ],
    },
  ];

  const sections2 = [
    {
      title: "ATUAÇÃO EM TODO O TERRITÓRIO NACIONAL",
      content: [
        "O grupo Custódio Quessada Lima tem clientes em todos os estados brasileiros. Durante nossa trajetória fomos responsáveis pela representação jurídica consultiva e contenciosa de interesses que envolvem milhares de hectares e operações rurais que somadas ultrapassam 1 bilhão de reais.",
      ],
    },
    {
      title: "RECONHECIMENTO E PREMIAÇÕES",
      content: [
        "Nos últimos anos, fomos espontaneamente reconhecidos pelo recebimento dos prêmios Top of Quality Brazil e Latin American Quality Institute, que, após a realização de pesquisas livres realizadas junto ao mercado do agrobusiness, concluíram que fomos recomendados e bem avaliados pelos produtores rurais entrevistados pelas entidades responsáveis pela organização dos prêmios.",
      ],
    },
  ];

  // Seção de empresas do ecossistema
  const companiesSection = {
    title: "SAIBA MAIS SOBRE AS EMPRESAS QUE COMPÕEM NOSSO ECOSSISTEMA",
    companies: [
      {
        name: "Custódio Quessada Lima Advogados",
        description:
          "Fundada em 2019, trabalha com representação consultiva e contenciosa de centenas de produtores rurais, com ênfase em revisão de garantias e reestruturação de recebíveis do agronegócio.",
      },
      {
        name: "Custódio Quessada Lima Soluções",
        description:
          "Escritório de apoio operacional com foco em triagem de documentos e facilitação da comunicação com nossa base de clientes, especialmente em relação aos serviços de suporte, relacionamento, Customer Relationship Management (CRM), Customer Experience (CX) e Customer Sucess (CS).",
      },
      {
        name: "CusQlim Company Consultores",
        description:
          "Consultoria técnica especializada na confecção de laudos contábeis e financeiros, e na elaboração de cálculos de atualização e revisão de índices e encargos de títulos de operações de crédito rural.",
      },
      {
        name: "Escola de Profissionalização da Atividade Rural (EPAR)",
        description:
          "Braço educacional do grupo que tem a missão de transmitir conhecimento em linguagem simples e acessível por meio de um programa de treinamento continuado que visa capacitar produtores rurais para tomada de decisões técnicas e embasadas em dados, retirando-os da condição de ter que assinar documentos sem entenderem o conteúdo do que estão assinando.",
      },
      {
        name: "Sequoia Agroclube",
        description:
          "Comunidade de clientes e usuários utilizada como ambiente para troca de experiências, networking e market place.",
      },
    ],
  };

  const QuemSomosCarouselFotos = [
    { src: "/assets/img/Sede1.png" },
    { src: "/assets/img/Sede2.png" },
    { src: "/assets/img/Sede3.png" },
    { src: "/assets/img/Sede4.png" },
    { src: "/assets/img/Sede5.png" },
    { src: "/assets/img/Sede6.png" },
    { src: "/assets/img/Sede7.png" },
    { src: "/assets/img/matheus.png" },
  ];

  return (
    <div>
      <HeroImage />
      <div className="flex-page-container">
        <br />
        <div className="magin-bottom"></div>
        <section id="page-content">
          <section id="presentation">
            <div className="div-small">
              <div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <div className="quem-somos-container">
                  {sections.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="quem-somos-target">
                      <h1 className={"h1-visible"}>{section.title}</h1>
                      {section.content.map((para, paraIndex) => (
                        <p
                          key={paraIndex}
                          className={"p-visible"}
                          dangerouslySetInnerHTML={{ __html: para }}
                        />
                      ))}
                    </div>
                  ))}
                </div>

                {/* Nova seção de empresas do ecossistema */}
                <div className="quem-somos-container">
                  <div className="quem-somos-target">
                    <h1 className={"h1-visible"}>{companiesSection.title}</h1>
                    <div className="companies-grid">
                      {companiesSection.companies.map((company, index) => (
                        <div key={index} className="company-item">
                          <h3 className="company-name">{company.name}</h3>
                          <div className="company-description">
                            {company.description}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="div-small">
                  <div className="gallery-container">
                    <button
                      className="nav-button left"
                      onClick={() =>
                        document
                          .querySelector(".image-gallery-left-nav")
                          .click()
                      }
                    >
                      <GoTriangleLeft />
                    </button>
                    <ImageGallery
                      items={QuemSomosCarouselFotos.map((photo) => ({
                        original: photo.src,
                        thumbnail: photo.src,
                      }))}
                      showFullscreenButton={true}
                      showPlayButton={true}
                      showThumbnails={true}
                      showBullets={true}
                      autoPlay={false} // Caso deseje desativar autoplay
                    />
                    <button
                      className="nav-button right"
                      onClick={() =>
                        document
                          .querySelector(".image-gallery-right-nav")
                          .click()
                      }
                    >
                      <GoTriangleRight />
                    </button>
                  </div>
                  <div className="margin"></div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />

                <div className="quem-somos-container">
                  {sections2.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="quem-somos-target">
                      <h1 className={"h1-visible"}>{section.title}</h1>
                      {section.content.map((para, paraIndex) => (
                        <p
                          key={paraIndex}
                          className={"p-visible"}
                          dangerouslySetInnerHTML={{ __html: para }}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="image-item">
              <img
                src="assets/img/PremioLAQI.jpeg"
                alt="Imagem 1"
                className="custom-image"
              />
              <img
                src="assets/img/PremioTQB.jpeg"
                alt="Imagem 2"
                className="custom-image"
              />
            </div>
          </section>
        </section>
        <ProcessoSeletivo />
      </div>
    </div>
  );
}

export default QuemSomos;
